import * as frappeSDK from "frappe-react-sdk";
const _f = (frappeSDK as any).default || frappeSDK;
const { useFrappeGetCall } = _f as Pick<typeof frappeSDK, "useFrappeGetCall">;

export interface PackageItem {
  item_code: string;
  description: string;
}

export interface HealthPackage {
  name: string;
  description: string | null;
  price: number | null;
  most_popular: boolean;
  items: PackageItem[];
}

export const useHealthPackages = () => {
  const { data, isLoading, error } = useFrappeGetCall<{ message: HealthPackage[] }>(
    "health_web.api.packages.get_packages",
    undefined,
    "health_packages",
  );

  return {
    packages: data?.message ?? [],
    isLoading,
    error,
  };
};
